// Imports => Constants
import { ENDPOINTS } from '@constants';

// Imports => Utilities
import { AcMemoize } from '@utils';

export class FilesAPI {
	constructor(Instance) {
		this.Store = Instance.Store;
		this.Client = Instance.Client;
		this.DownloadClient = Instance.DownloadClient;
	}

	index = AcMemoize(() => {
		return this.Client.get(ENDPOINTS.FILES.INDEX).then((response) => response.data);
	});

	download = AcMemoize((id, type) => {
		if (type === 'document') {
			return this.Client.get(ENDPOINTS.DOCUMENTS.DOWNLOAD(id)).then(
				(response) => response
			);
		}

		return this.DownloadClient.get(ENDPOINTS.DOCUMENTS.DOWNLOAD(id)).then(
			(response) => response
		);
	});
}

export default FilesAPI;
